type FormInputFieldProps = {
    title: string
    children: React.ReactNode
}

const FormField = ({title, children}: FormInputFieldProps) => {
    return (
        <div className="flex flex-col gap-1">
            <div className="pl-5 text-sm">{title}</div>
            <div className="flex">{children}</div>
        </div>
    )
}

export default FormField
